const en_groups = {
    add: "add groups",
    barcode: "barcode",
    edit: "edit groups",
    name: 'groups name',
    order_min: "minimum order",
    price: "price groups",
    stock_min: 'minimum stock warning',
    upload: "upload groups",
    // barcode: "print barcode",
    view: "groups detail",
    error: {
        brand: 'pricipal cannot be empty',
        category: 'groups category cannot be empty',
        name: 'groups name cannot be empty',
        unit: 'groups unit cannot be empty',
    }
}

const id_groups = {
    add: "tambah kelompok",
    barcode: "barcode",
    edit: "ubah kelompok",
    name: 'nama kelompok',
    order_min: "minimum pesanan",
    price: "harga kelompok",
    stock_min: 'peringatan minimum stok',
    upload: "unggah kelompok",
    // barcode: "cetak barcode",
    view: "detail kelompok",
    error: {
        barcode: 'barcode tidak boleh kosong',
        brand: 'pricipal tidak boleh kosong',
        category: 'kategori barang tidak boleh kosong',
        name: 'nama barang tidak boleh kosong',
        sku: 'SKU tidak boleh kosong',
        unit: 'unit barang tidak boleh kosong',
    }
}

export { en_groups, id_groups };